/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const baseOptions = {
	closeOnEscape: false,
	closeOnClickOutside: false,
	keyCodeForClose: [8, 32],
	willUnmount: () => {},
	afterClose: () => {},
	onClickOutside: () => {},
	onKeypress: () => {},
	onKeypressEscape: () => {},
	overlayClassName: "pretty-dialog"
};

function prettyAlert(title, message = "", okTextButton = "OK") {
	const options = {
		title: title,
		message: message,
		customUI: ({ title, message, onClose }) => {
			return (
				<div className='react-confirm-alert-body custom-ui'>
					<h1>{title}</h1>
					
					<p>{message}</p>
					
					<button className='btn btn-primary btn-block' onClick={onClose}>{okTextButton}</button>
				</div>
			);
		}
	};

	confirmAlert({...baseOptions, ...options});
}

function prettyConfirm( title, message = "", 
						yesTextButton = "Confirmar", noTextButton = "Cancelar", 
						yesCallback = () => {}, noCallback = () => {},
						yesClassname = "btn btn-danger", noClassname= "btn btn-light") {
		
	const options = {
		title: title,
		message: message,
		customUI: ({ title, message, onClose }) => {
			return (
				<div className='react-confirm-alert-body custom-ui'>
					<h1>{title}</h1>
					<p>{message}</p>
					
					<div className='buttons'> 
						<button className={noClassname} onClick={() => { noCallback(); onClose(); }}>
							{noTextButton}
						</button>
						<button className={yesClassname} onClick={() => { yesCallback(); onClose(); }}>
							{yesTextButton}
						</button>
					</div>
				</div>
			);
		}
	};
	
	confirmAlert({...baseOptions, ...options});
}

export { prettyAlert, prettyConfirm };


// WEBPACK FOOTER //
// ./src/components/Common/Dialog.js